import { render } from "./Team.vue?vue&type=template&id=16ec7a84&scoped=true&ts=true"
import script from "./Team.vue?vue&type=script&lang=ts"
export * from "./Team.vue?vue&type=script&lang=ts"

import "./Team.vue?vue&type=style&index=0&id=16ec7a84&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ec7a84"]])

export default __exports__